class PromotersDelegate {
    setRows(rows) {
        this.setState((prevState) => {
            return { rows };
        });
    }
}

export default PromotersDelegate;
